import { useState } from "react";
import { MdDeleteForever, MdModeEdit } from "react-icons/md";
import axiosInstance from "../../api/axiosInstance.js";
import Model from "../../common/Model/index.js";
import Select from "react-select";
import { notify } from "../../common/Toast/index.js";

const FinsMaterialItemTable = ({
  items,
  handleItemDelete,
  allItems,
  setItems,
  coatingColors,
  handleItemSelect,
  selectedCoatingPartyId,
  isCoatingModalOpen,
  setIsCoatingModalOpen,
  setCoatingColors,
  setIsItemModalOpen,
  isItemModalOpen,
  setAllItems,
  fetchDropdownData,
  errors,
  permission,
  coatingType,
}) => {
  const userId = sessionStorage.getItem("userId");

  const [newCoatingColor, setNewCoatingColor] = useState({
    coating_Color_Name: "",
    coating_Color_Code: "",
  });

  const [formData, setFormData] = useState({
    itemId: "",
    itemName: "",
    itemType: "",
    description: "",
    rate: "",
  });

  const [isEditingCoatingColor, setIsEditingCoatingColor] = useState(false);
  const [editCoatingColorId, setEditCoatingColorId] = useState(null);
  const filteredCoatingColors = coatingColors.filter(
    (color) => color.coating_Party_Id === Number(selectedCoatingPartyId)
  );

  const handleAddOrUpdateCoatingColor = async () => {
    try {
      const payload = {
        Coating_Color_Id: isEditingCoatingColor ? editCoatingColorId : 0,
        Coating_Party_Id: Number(selectedCoatingPartyId),
        Coating_Color_Name: newCoatingColor.coating_Color_Name,
        Coating_Color_Code: newCoatingColor.coating_Color_Code,
      };

      const apiUrl = isEditingCoatingColor
        ? "MaterialQuotation/UpdateCoatingColor"
        : "MaterialQuotation/SaveCoatingColor";

      await axiosInstance.post(apiUrl, payload);

      notify(
        isEditingCoatingColor
          ? "Coating Color updated successfully!"
          : "Coating Color added successfully!",
        "success"
      );

      fetchDropdownData(
        "MaterialQuotation/GetAllCoatingColors",
        setCoatingColors
      );
      if (isEditingCoatingColor) {
        setItems((prevItems) =>
          prevItems.map((item) =>
            item.coating_Color_Id === editCoatingColorId
              ? { ...item, coating_Color_Id: editCoatingColorId }
              : item
          )
        );
      }

      setIsCoatingModalOpen(false);
      setNewCoatingColor({ coating_Color_Name: "", coating_Color_Code: "" });
      setIsEditingCoatingColor(false);
      setEditCoatingColorId(null);
    } catch (error) {
      console.error("Error adding/updating coating color:", error);
    }
  };

  const handleCoatingColorEdit = async (id) => {
    try {
      const { data } = await axiosInstance.get(
        `MaterialQuotation/GetCoatingColorById/${id}`
      );
      setNewCoatingColor({
        coating_Color_Name: data.coating_Color_Name,
        coating_Color_Code: data.coating_Color_Code,
      });
      setEditCoatingColorId(id);
      setIsEditingCoatingColor(true);
      setIsCoatingModalOpen(true);
    } catch (error) {
      console.error("Error fetching coating color:", error);
    }
  };

  const itemOptions = [
    ...allItems?.map((item) => ({
      value: item.itemId?.toString() || "",
      label: item.itemName || "Unnamed Item",
    })),
    { value: "add-newItem", label: "+ Add New Item" },
  ];
  const colorOptions = [
    ...filteredCoatingColors.map((color) => ({
      value: color.coating_Color_Id,
      label: `${color.coating_Color_Name} `,
    })),
    { value: "add-new", label: "+ Add New Coating Color" },
  ];
  const coatingTypeOptions = [
    ...coatingType.map((type) => ({
      value: type.coatingTypeId,
      label: `${type.coatingType} `,
    })),
  ];

  const fetchItemsData = async () => {
    try {
      const response = await axiosInstance.get("FinsItem/GetAll");
      setAllItems(response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  const handleItemSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        itemId: formData.itemId || 0,
        itemName: formData.itemName,
        description: formData.description,
        itemType: formData.itemType,
        rate: formData.rate,
        modifiedBy: userId,
        createdBy: userId,
      };

      await axiosInstance.post("FinsItem/SaveOrUpdate", payload);
      setIsItemModalOpen(false);
      fetchItemsData();
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };

  return (
    <>
      <div className="bg-white rounded-lg shadow-md mt-6">
        <div className="bg-[#f1f4f9] px-6 py-4 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-base font-semibold text-[#405189]">Item List </h2>
        </div>
        <div className="w-full overflow-x-auto rounded-lg p-2">
          <table className="w-full table-fixed border-collapse">
            <colgroup>
              <col className="w-14" />
              <col className="w-[18rem]" />
              <col className="w-[14rem]" />
              <col className="w-[14rem]" />
              <col className="w-32" />
              <col className="w-24" />
              <col className="w-28" />
              <col className="w-32" />
              <col className="w-32" />
              {permission?.isDelete && <col className="w-24" />}
            </colgroup>

            <thead className="bg-[#e8ecff] text-[#1f2366] sticky top-0 z-10">
              <tr className="[&>th]:px-3 [&>th]:py-3 [&>th]:text-left [&>th]:text-sm [&>th]:font-semibold [&>th]:border-b [&>th]:border-gray-200">
                <th>No</th>
                <th>Item Name</th>
                <th>Coating Color</th>
                <th>Coating Type</th>
                <th>Panel Size (MM)</th>
                <th>Qty</th>
                <th>Total RFT</th>
                <th>Rate</th>
                <th>Amount</th>
                {permission?.isDelete && (
                  <th className="text-center">Actions</th>
                )}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {items.map((item, index) => (
                <tr
                  key={index}
                  className="odd:bg-white even:bg-[#fafbff] hover:bg-indigo-50/40 transition-colors"
                >
                  <td className="border border-gray px-3 py-2">
                    {item.seQ_NO}
                  </td>
                  <td className="border  border-gray px-3 py-2 ">
                    <Select
                      options={itemOptions}
                      value={
                        itemOptions.find(
                          (option) =>
                            String(option.value) ===
                            String(items[index]?.itemId)
                        ) || null
                      }
                      menuPortalTarget={document.body}
                      isClearable
                      isSearchable
                      onChange={(selectedOption) => {
                        if (selectedOption?.value === "add-newItem") {
                          setFormData({
                            itemId: "",
                            itemName: "",
                            itemType: "",
                            description: "",
                            rate: "",
                          });
                          setIsItemModalOpen(true);
                        } else {
                          handleItemSelect(index, selectedOption, "itemId");
                        }
                      }}
                      name="itemId"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          borderColor: "gray",
                          boxShadow: "none",
                          "&:hover": { borderColor: "gray" },
                        }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (provided) => ({
                          ...provided,
                          maxHeight: "200px",
                          overflowY: "auto",
                        }),
                        menuList: (provided) => ({
                          ...provided,
                          maxHeight: "200px",
                          overflowY: "auto",
                        }),
                        option: (provided, { data }) => ({
                          ...provided,
                          backgroundColor:
                            data.value === "add-newItem"
                              ? "#F3F4F6"
                              : provided.backgroundColor,
                          fontWeight:
                            data.value === "add-newItem" ? "bold" : "normal",
                          cursor: "pointer",
                          position:
                            data.value === "add-newItem"
                              ? "sticky"
                              : "relative",
                          bottom: data.value === "add-newItem" ? "0" : "auto",
                        }),
                      }}
                    />
                  </td>
                  <td className="border border-gray px-3 py-2 ">
                    <div className="flex items-center gap-2">
                      <div className="flex-1">
                        <Select
                          options={colorOptions}
                          value={
                            colorOptions.find(
                              (option) =>
                                option.value === items[index]?.coating_Color_Id
                            ) || null
                          }
                          menuPortalTarget={document.body}
                          isClearable
                          isSearchable
                          onChange={(selectedOption) =>
                            handleItemSelect(
                              index,
                              selectedOption,
                              "coating_Color_Id"
                            )
                          }
                          name="coating_Color_Id"
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              borderColor: "gray",
                              boxShadow: "none",
                              "&:hover": { borderColor: "gray" },
                            }),
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            menu: (provided) => ({
                              ...provided,
                              maxHeight: "200px",
                              overflowY: "auto",
                            }),
                            menuList: (provided) => ({
                              ...provided,
                              maxHeight: "200px",
                              overflowY: "auto",
                            }),
                            option: (provided, { data }) => ({
                              ...provided,
                              backgroundColor:
                                data.value === "add-new"
                                  ? "#F3F4F6"
                                  : provided.backgroundColor,
                              fontWeight:
                                data.value === "add-new" ? "bold" : "normal",
                              cursor: "pointer",
                              position:
                                data.value === "add-new"
                                  ? "sticky"
                                  : "relative",
                              bottom: data.value === "add-new" ? "0" : "auto",
                            }),
                          }}
                        />
                      </div>
                      {items[index]?.coating_Color_Id && (
                        <button
                          type="button"
                          onClick={() =>
                            handleCoatingColorEdit(
                              items[index]?.coating_Color_Id
                            )
                          }
                          className="text-primary"
                        >
                          <MdModeEdit />
                        </button>
                      )}
                    </div>
                  </td>
                  <td className="border border-gray px-3 py-2 ">
                    <div className="flex items-center gap-2">
                      <div className="flex-1">
                        <Select
                          options={coatingTypeOptions}
                          value={
                            coatingTypeOptions.find(
                              (option) =>
                                option.value === items[index]?.coatingTypeId
                            ) || null
                          }
                          menuPortalTarget={document.body}
                          isClearable
                          isSearchable
                          onChange={(selectedOption) =>
                            handleItemSelect(
                              index,
                              selectedOption,
                              "coatingTypeId"
                            )
                          }
                          name="coatingTypeId"
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              borderColor: "gray",
                              boxShadow: "none",
                              "&:hover": { borderColor: "gray" },
                            }),
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            menu: (provided) => ({
                              ...provided,
                              maxHeight: "200px",
                              overflowY: "auto",
                            }),
                            menuList: (provided) => ({
                              ...provided,
                              maxHeight: "200px",
                              overflowY: "auto",
                            }),
                          }}
                        />
                      </div>
                    </div>
                  </td>
                  <td className="border border-gray px-3 py-2">
                    <input
                      className="border rounded p-2 w-full outline-none focus:ring-2 focus:ring-primary"
                      name="panel_Size"
                      value={items[index]?.panel_Size || 0}
                      onChange={(e) => handleItemSelect(index, e)}
                    />
                  </td>
                  <td className="border border-gray px-3 py-2">
                    <input
                      className="border rounded p-2 w-full outline-none focus:ring-2 focus:ring-primary"
                      name="qty"
                      value={items[index]?.qty || 0}
                      onChange={(e) => handleItemSelect(index, e)}
                    />
                  </td>
                  <td className="border border-gray px-3 py-2">
                    {item.total_RFT.toFixed(2)}
                  </td>
                  <td className="border border-gray px-3 py-2">
                    <input
                      type="text"
                      className="p-2 rounded w-full border outline-none focus:ring-2 focus:ring-primary "
                      name="rate"
                      value={Math.round(items[index]?.rate)}
                      onChange={(e) => handleItemSelect(index, e)}
                      disabled={userId !== "1" && userId !== "19"}
                    />
                  </td>
                  <td className="border border-gray px-3 py-2">
                    {item.amount?.toFixed(2)}
                  </td>
                  {permission?.isDelete && (
                    <td className="border border-gray px-3 py-2">
                      <button
                        type="button"
                        className="ml-2 px-3 py-2 text-sm font-medium text-danger bg-red-100 rounded-md hover:bg-red-200 outline-none focus:ring-2 focus:ring-red-500"
                        onClick={() => handleItemDelete(index)}
                      >
                        <MdDeleteForever className="w-5 h-5" />
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <button
          type="button"
          className="px-3 py-2 text-sm font-medium  text-white bg-secondary rounded-md m-6"
          onClick={() =>
            setItems((prevItems) => [
              ...prevItems,
              {
                itemId: "",
                itemName: "",
                coating_Color_Id: "",
                coatingTypeId: 1,
                panel_Size: 0,
                qty: 0,
                total_RFT: 0,
                rate: 0,
                amount: 0,
                seQ_NO: prevItems.length + 1,
              },
            ])
          }
        >
          + Add Item
        </button>

        {errors.items && (
          <p className="text-red-500 text-xs mt-1">{errors.items}</p>
        )}
      </div>
      <Model
        isOpen={isCoatingModalOpen}
        onClose={() => setIsCoatingModalOpen(false)}
        name="Add Coating Color"
      >
        <div className="p-4 space-y-4">
          <input
            type="text"
            placeholder="Coating Color Name"
            className="border p-2 w-full"
            value={newCoatingColor.coating_Color_Name}
            onChange={(e) =>
              setNewCoatingColor((prev) => ({
                ...prev,
                coating_Color_Name: e.target.value,
              }))
            }
          />
          <input
            type="text"
            placeholder="Coating Color Code"
            className="border p-2 w-full"
            value={newCoatingColor.coating_Color_Code}
            onChange={(e) =>
              setNewCoatingColor((prev) => ({
                ...prev,
                coating_Color_Code: e.target.value,
              }))
            }
          />
          <button
            type="button"
            onClick={handleAddOrUpdateCoatingColor}
            className="px-3 py-2 text-sm font-medium rounded bg-primary text-white"
          >
            {isEditingCoatingColor ? "Update" : "Add"}
          </button>
          <button
            type="button"
            onClick={() => setIsCoatingModalOpen(false)}
            className="px-3 py-2 border border-gray text-sm font-medium rounded bg-white ml-4"
          >
            Cancel
          </button>
        </div>
      </Model>
      <Model
        isOpen={isItemModalOpen}
        onClose={() => setIsItemModalOpen(false)}
        name="Add New Item"
      >
        <div className=" space-y-4">
          <select
            className="w-full px-3 py-2 border rounded-md"
            name="itemType"
            value={formData.itemType}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, itemType: e.target.value }))
            }
          >
            <option value="">Select Item Type</option>
            <option value="Aluminium">Aluminium</option>
            <option value="GI">GI</option>
          </select>
          <input
            type="text"
            placeholder="Item Name"
            className="border p-2 w-full"
            value={formData.itemName}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, itemName: e.target.value }))
            }
          />
          <input
            type="text"
            placeholder="Description"
            className="border p-2 w-full"
            value={formData.description}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, description: e.target.value }))
            }
          />
          <input
            placeholder="Rate"
            className="border p-2 w-full"
            name="rate"
            value={formData.rate}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, rate: e.target.value }))
            }
          />
          <button
            type="button"
            onClick={handleItemSubmit}
            className="px-3 py-2 text-sm font-medium rounded bg-primary text-white"
          >
            {isEditingCoatingColor ? "Update" : "Add"}
          </button>
          <button
            type="button"
            onClick={() => setIsItemModalOpen(false)}
            className="px-3 py-2 border border-gray text-sm font-medium rounded bg-white ml-4"
          >
            Cancel
          </button>
        </div>
      </Model>
    </>
  );
};

export default FinsMaterialItemTable;
